if (!customElements.get('main-cart-lec')) {
  // Adds use this flag so the cart drawer stays closed on the cart page.
  // The drawer still refreshes in the background (see refreshDrawer).
  var MC_QUIET = 'cd-note=1';

  customElements.define(
    'main-cart-lec',
    class MainCartLec extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.rootUrl = this.dataset.root || '/';
        if (!this.rootUrl.endsWith('/')) this.rootUrl += '/';
        this.itemCount = parseInt(this.dataset.itemCount, 10) || 0;
        this.inCart = new Set();
        this.money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP' });

        this.addEventListener('click', this.onClick.bind(this));
        this.bindNote();
        this.loadRecommendations();
        this.watchSticky();
        this.rotateReviews();
      }

      // Show 2 reviews at a time; with 3 reviews, cycle through them every 6 seconds.
      rotateReviews() {
        var wrap = this.querySelector('[data-mc-reviews]');
        if (!wrap) return;
        var reviews = Array.from(wrap.querySelectorAll('[data-mc-review]'));
        if (reviews.length <= 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.Shopify && window.Shopify.designMode) return;
        var start = 0;
        var paused = false;
        wrap.addEventListener('mouseenter', function () {
          paused = true;
        });
        wrap.addEventListener('mouseleave', function () {
          paused = false;
        });
        setInterval(function () {
          if (paused || document.hidden) return;
          start = (start + 1) % reviews.length;
          reviews.forEach(function (review, index) {
            var offset = (index - start + reviews.length) % reviews.length;
            review.hidden = offset > 1;
          });
        }, 6000);
      }

      onClick(event) {
        var qty = event.target.closest('[data-mc-qty]');
        if (qty) {
          this.change(qty.dataset.key, parseInt(qty.dataset.mcQty, 10));
          return;
        }
        var remove = event.target.closest('[data-mc-remove]');
        if (remove) {
          var updates = {};
          remove.dataset.mcRemove
            .split(',')
            .filter(Boolean)
            .forEach(function (key) {
              updates[key] = 0;
            });
          this.request('cart/update.js', { updates: updates });
          return;
        }
        var add = event.target.closest('[data-mc-add]');
        if (add) this.add(add);
      }

      post(path, body) {
        return fetch(this.rootUrl + path, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body),
        }).then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw new Error(data.description || data.message || 'error');
            return data;
          });
        });
      }

      setBusy(busy) {
        this.classList.toggle('is-busy', busy);
      }

      showError(message) {
        var el = this.querySelector('[data-mc-error]');
        if (!el) return;
        el.textContent = message && message !== 'error' ? message : this.dataset.errorText;
        el.hidden = false;
      }

      clearError() {
        var el = this.querySelector('[data-mc-error]');
        if (el) el.hidden = true;
      }

      change(key, quantity) {
        this.request('cart/change.js', { id: key, quantity: Math.max(0, quantity) });
      }

      request(path, body) {
        var self = this;
        body.sections = this.sectionId + ',cart-icon-bubble';
        body.sections_url = window.location.pathname;
        this.setBusy(true);
        this.clearError();
        return this.post(path, body)
          .then(function (data) {
            self.apply(data.sections);
          })
          .catch(function (error) {
            self.showError(error.message);
          })
          .finally(function () {
            self.setBusy(false);
          });
      }

      add(button) {
        var self = this;
        var label = button.textContent;
        button.disabled = true;
        this.clearError();
        this.post('cart/add.js?' + MC_QUIET, {
          items: [{ id: parseInt(button.dataset.mcAdd, 10), quantity: 1 }],
          sections: this.sectionId + ',cart-icon-bubble',
          sections_url: window.location.pathname,
        })
          .then(function (data) {
            var productId = button.dataset.productId;
            if (productId) self.inCart.add(String(productId));
            self.apply(data.sections);
            self.refreshDrawer();
            var card = button.closest('[data-mc-rec]');
            if (card) {
              card.remove();
              self.fillRecommendations();
            }
          })
          .catch(function (error) {
            button.disabled = false;
            button.textContent = label;
            self.showError(error.message);
          });
      }

      refreshDrawer() {
        var drawer = document.querySelector('cart-drawer-lec');
        if (drawer && typeof drawer.refresh === 'function') drawer.refresh(false);
      }

      apply(sections) {
        if (!sections) return;
        this.updateBubble(sections['cart-icon-bubble']);
        var html = sections[this.sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('main-cart-lec');
        if (!fresh) return;
        var newCount = parseInt(fresh.dataset.itemCount, 10) || 0;
        if ((newCount === 0) !== (this.itemCount === 0)) {
          window.location.reload();
          return;
        }
        this.itemCount = newCount;
        var self = this;
        fresh.querySelectorAll('[data-mc-part]').forEach(function (part) {
          var current = self.querySelector('[data-mc-part="' + part.dataset.mcPart + '"]');
          if (current) current.innerHTML = part.innerHTML;
        });
      }

      updateBubble(html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }

      bindNote() {
        var note = this.querySelector('[data-mc-note]');
        if (!note) return;
        var self = this;
        note.addEventListener('input', function () {
          clearTimeout(self.noteTimer);
          self.noteTimer = setTimeout(function () {
            fetch(self.rootUrl + 'cart/update.js?' + MC_QUIET, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ note: note.value }),
            }).catch(function () {});
          }, 500);
        });
      }

      // "You might also like": Shopify's recommended products for the first item in the bag.
      loadRecommendations() {
        var wrap = this.querySelector('[data-mc-recs]');
        if (!wrap) return;
        this.inCart = new Set((wrap.dataset.cartProducts || '').split(',').filter(Boolean));
        this.recPool = [];
        var productId = wrap.dataset.productId;
        if (!productId) return;
        var self = this;
        fetch(this.rootUrl + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related', {
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            self.recPool = (data.products || []).filter(function (product) {
              if (!product.available || product.gift_card) return false;
              return (product.variants || []).some(function (v) {
                return v.available;
              });
            });
            self.fillRecommendations();
          })
          .catch(function () {});
      }

      fillRecommendations() {
        var wrap = this.querySelector('[data-mc-recs]');
        var list = wrap && wrap.querySelector('[data-mc-recs-list]');
        if (!list || !this.recPool) return;
        var shown = new Set(
          Array.from(list.querySelectorAll('[data-mc-rec]')).map(function (card) {
            return card.dataset.productId;
          })
        );
        var self = this;
        this.recPool.forEach(function (product) {
          if (list.children.length >= 4) return;
          var id = String(product.id);
          if (shown.has(id) || self.inCart.has(id)) return;
          shown.add(id);
          list.appendChild(self.card(product));
        });
        wrap.hidden = list.children.length === 0;
      }

      card(product) {
        var variant =
          (product.variants || []).find(function (v) {
            return v.available;
          }) || product.variants[0];
        var li = document.createElement('li');
        li.className = 'mc-card';
        li.dataset.mcRec = '';
        li.dataset.productId = product.id;

        var media = document.createElement('a');
        media.className = 'mc-card__media';
        media.href = product.url;
        media.tabIndex = -1;
        media.setAttribute('aria-hidden', 'true');
        var src = product.featured_image || (product.images && product.images[0]);
        if (src) {
          var img = document.createElement('img');
          var url = new URL(src.indexOf('//') === 0 ? 'https:' + src : src, window.location.origin);
          url.searchParams.set('width', '400');
          url.searchParams.set('height', '400');
          url.searchParams.set('crop', 'center');
          img.src = url.toString();
          img.alt = '';
          img.loading = 'lazy';
          img.width = 400;
          img.height = 400;
          media.appendChild(img);
        }

        var name = document.createElement('a');
        name.className = 'mc-card__name';
        name.href = product.url;
        name.textContent = product.title;

        var price = document.createElement('span');
        price.className = 'mc-card__price';
        price.textContent = this.money.format((variant.price || product.price || 0) / 100);

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mc-card__add';
        button.dataset.mcAdd = variant.id;
        button.dataset.productId = product.id;
        button.textContent = this.dataset.addLabel || '+ Add';
        button.setAttribute('aria-label', (this.dataset.addLabel || '+ Add') + ': ' + product.title);

        li.append(media, name, price, button);
        return li;
      }

      // Mobile: hide the sticky checkout bar while the summary's own checkout button is on screen.
      watchSticky() {
        var sticky = this.querySelector('[data-mc-sticky]');
        var target = this.querySelector('[data-mc-checkout-main]');
        if (!sticky || !target || !('IntersectionObserver' in window)) return;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('is-hidden', entry.isIntersecting);
          });
        }).observe(target);
      }
    }
  );
}
